import React from 'react';
import PropTypes from 'prop-types';
import styles from './EkomiComponent.less';
import StarRating, { ratingFormat } from '../StarRating/StarRating';

const iconSrc =
  'https://www.static-immobilienscout24.de/statpic/shared-services/it/atlas/icons/942e0afde8383f3288e4e09b42571a19_ekomi.png';
const countFormat = new Intl.NumberFormat('de-DE', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

const EkomiComponent = ({ count, link, rating }) => (
  <div className={styles.ekomiComponent}>
    <div className={styles.main}>
      <div className="grid grid-flex grid-fill-rows gutter-m">
        <div className="grid-item grid-item-fixed-width">
          <a href={link} target="_blank" rel="noreferrer">
            <img alt="" src={iconSrc} />
          </a>
        </div>
        <div className="grid-item one-half font-lightgray font-xs font-line-s">
          <div>
            <StarRating ratingValue={rating} />
            <span className={styles.ratingLabel}>{ratingFormat.format(rating)} / 5</span>
          </div>
          <div className="padding-top-s">
            über {countFormat.format(count)} Bewertungen auf{' '}
            <a href={link} className="font-lightgray" target="_blank" rel="noreferrer">
              eKomi
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
);

EkomiComponent.propTypes = {
  count: PropTypes.number.isRequired,
  rating: PropTypes.number.isRequired,
  link: PropTypes.string.isRequired,
};

export default EkomiComponent;
